/* Coquillettes Club — GSAP Animations */

gsap.registerPlugin(ScrollTrigger);

/* ─── CSS utilitaires word-reveal ─────────────────────── */
(function injectStyles() {
  const style = document.createElement('style');
  style.textContent = `
    .gsap-word-wrap {
      display: inline-block;
      overflow: hidden;
      vertical-align: bottom;
      line-height: inherit;
    }
    .gsap-word-inner {
      display: inline-block;
    }
  `;
  document.head.appendChild(style);
})();

/* ─── Helpers ─────────────────────────────────────────── */
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ─── A. Révélation de texte mot par mot ──────────────── */
function wordReveal(el, options) {
  if (!el) return;
  const opts = Object.assign({ stagger: 0.055, duration: 0.65, delay: 0, start: 'top 85%' }, options);

  const original = el.textContent.trim();
  const words    = original.split(/\s+/);

  el.innerHTML = words
    .map(w => `<span class="gsap-word-wrap"><span class="gsap-word-inner">${w}</span></span>`)
    .join(' ');
  el.setAttribute('aria-label', original);

  gsap.fromTo(
    el.querySelectorAll('.gsap-word-inner'),
    { y: '105%', opacity: 0 },
    {
      y: '0%',
      opacity: 1,
      duration: opts.duration,
      stagger: opts.stagger,
      delay: opts.delay,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: opts.start,
        toggleActions: 'play none none none',
        once: true,
      }
    }
  );
}

/* ─── C. Compteur animé ───────────────────────────────── */
function counterAnimate(el, decimals, options) {
  if (!el) return;
  const opts = Object.assign({ duration: 2, ease: 'power2.out', start: 'top 85%' }, options);

  const raw    = el.textContent.trim();
  const target = parseFloat(raw.replace(/[^\d.]/g, ''));
  if (isNaN(target)) return;

  const obj = { val: 0 };
  gsap.to(obj, {
    val: target,
    duration: opts.duration,
    ease: opts.ease,
    onUpdate() {
      el.textContent = obj.val.toFixed(decimals);
    },
    scrollTrigger: {
      trigger: el,
      start: opts.start,
      toggleActions: 'play none none none',
      once: true,
    }
  });
}

/* ─── Init ────────────────────────────────────────────── */
if (prefersReducedMotion) {
  ScrollTrigger.getAll().forEach(t => t.kill());
} else {
  init();
}

function init() {

  /* ─── 0. Marquee logos presse ───────────────────────── */
  gsap.utils.toArray('[data-marquee]').forEach(wrapper => {
    const list = wrapper.querySelector('.logos-presse__list');
    if (!list) return;

    const speed  = parseFloat(wrapper.dataset.marqueeSpeed) || 30;
    const origItems = Array.from(list.children);
    if (!origItems.length) return;

    // Un seul clone — les fades masquent les bords, pas de doublon visible
    origItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      list.appendChild(clone);
    });

    const singleW = list.scrollWidth / 2;

    const tween = gsap.to(list, {
      x: -singleW,
      duration: speed,
      ease: 'none',
      repeat: -1,
    });

    // Décélération fluide au survol via timeScale
    wrapper.addEventListener('mouseenter', () =>
      gsap.to(tween, { timeScale: 0, duration: 0.6, ease: 'power2.out', overwrite: true })
    );
    wrapper.addEventListener('mouseleave', () =>
      gsap.to(tween, { timeScale: 1, duration: 0.5, ease: 'power2.in', overwrite: true })
    );
  });

  /* ─── 1. Hero Coquillettes ──────────────────────────── */
  const heroText = document.querySelector('.hero-cq__text');
  if (heroText) {
    gsap.fromTo(
      heroText.children,
      { opacity: 0, y: 32 },
      { opacity: 1, y: 0, duration: 0.75, stagger: 0.13, ease: 'power3.out', delay: 0.15 }
    );

    const heroFrame = document.querySelector('.hero-cq__media-frame');
    if (heroFrame) {
      gsap.fromTo(heroFrame,
        { opacity: 0, x: 48, rotate: 0 },
        { opacity: 1, x: 0, rotate: 1.5, duration: 1, ease: 'power3.out', delay: 0.25 }
      );
    }

    const heroBadge = document.querySelector('.hero-cq__badge');
    if (heroBadge) {
      gsap.fromTo(heroBadge,
        { opacity: 0, scale: 0.5, rotate: -20 },
        { opacity: 1, scale: 1, rotate: -8, duration: 0.65, ease: 'back.out(2)', delay: 0.8 }
      );
    }
  }

  /* ─── 1c. Kit découverte ────────────────────────────── */
  const kitSection = document.querySelector('.kit-decouverte');
  if (kitSection) {
    const st = { trigger: kitSection, start: 'top 78%', toggleActions: 'play none none none' };
    const kitFrame = kitSection.querySelector('.kit-decouverte__media-frame');
    const kitTextEls = kitSection.querySelectorAll(
      '.kit-decouverte__eyebrow, .kit-decouverte__heading, .kit-decouverte__sub'
    );
    const kitItems = kitSection.querySelectorAll('.kit-decouverte__item');
    const kitCta   = kitSection.querySelector('.kit-decouverte__cta');

    if (kitFrame) gsap.fromTo(kitFrame,
      { opacity: 0, x: -50, rotate: 0 },
      { opacity: 1, x: 0, rotate: -2, duration: 0.9, ease: 'power3.out', scrollTrigger: st }
    );
    if (kitTextEls.length) gsap.fromTo(kitTextEls,
      { opacity: 0, x: 40 },
      { opacity: 1, x: 0, duration: 0.7, stagger: 0.12, ease: 'power3.out', delay: 0.15, scrollTrigger: st }
    );
    if (kitItems.length) gsap.fromTo(kitItems,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.45, stagger: 0.09, ease: 'power2.out', delay: 0.35, scrollTrigger: st }
    );
    if (kitCta) gsap.fromTo(kitCta,
      { opacity: 0, y: 16 },
      { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out', delay: 0.85, scrollTrigger: st }
    );
  }

  /* ─── 2. Image-with-text — slide depuis le côté ──────── */
  gsap.utils.toArray('.image-with-text').forEach(section => {
    const media   = section.querySelector('.image-with-text__media-item');
    const content = section.querySelector('.image-with-text__text-item');
    const isRev   = !!section.querySelector('.image-with-text__grid--reverse');

    const st = { trigger: section, start: 'top 80%', toggleActions: 'play none none none' };

    if (media)   gsap.fromTo(media,   { opacity: 0, x: isRev ?  60 : -60 }, { opacity: 1, x: 0, duration: 0.9, ease: 'power3.out', scrollTrigger: st });
    if (content) gsap.fromTo(content, { opacity: 0, x: isRev ? -60 :  60 }, { opacity: 1, x: 0, duration: 0.9, ease: 'power3.out', delay: 0.15, scrollTrigger: st });
  });

  /* ─── 3. Titres de section — fade + slide up ─────────── */
  gsap.utils.toArray([
    '.rich-text__heading',
    '.collage-wrapper-title',
    '.multicolumn-list__title',
    '.featured-collection__title',
    'h2.inline-richtext',
  ].join(',')).forEach(el => {
    if (el.classList.contains('scroll-trigger')) return;
    gsap.fromTo(el,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' }
      }
    );
  });

  /* ─── 4. Cartes produit — stagger ───────────────────── */
  gsap.utils.toArray('.product-card-wrapper, .card-wrapper').forEach((card, i) => {
    gsap.fromTo(card,
      { opacity: 0, y: 50, scale: 0.97 },
      { opacity: 1, y: 0, scale: 1, duration: 0.6, ease: 'power2.out',
        delay: (i % 4) * 0.1,
        scrollTrigger: { trigger: card, start: 'top 88%', toggleActions: 'play none none none' }
      }
    );
  });

  /* ─── 5. Multicolumn ─────────────────────────────────── */
  const multicolItems = gsap.utils.toArray('.multicolumn-list__item, .multicolumn-card');
  if (multicolItems.length) {
    gsap.fromTo(multicolItems,
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'back.out(1.4)',
        scrollTrigger: {
          trigger: multicolItems[0].closest('ul, .multicolumn-list') || multicolItems[0],
          start: 'top 80%', toggleActions: 'play none none none'
        }
      }
    );
  }

  /* ─── 6. Parallax bannières ──────────────────────────── */
  gsap.utils.toArray('.banner__media, .image-banner').forEach(el => {
    gsap.to(el, {
      yPercent: -12, ease: 'none',
      scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  });

  /* ─── 6a. Réassurance ───────────────────────────────── */
  const reasCards = gsap.utils.toArray('.reas__card');
  if (reasCards.length) {
    gsap.fromTo(reasCards,
      { opacity: 0, y: 36, scale: 0.96 },
      { opacity: 1, y: 0, scale: 1, duration: 0.55, stagger: 0.1, ease: 'back.out(1.4)',
        scrollTrigger: { trigger: reasCards[0].closest('.reas'), start: 'top 85%', toggleActions: 'play none none none' }
      }
    );
  }

  /* ─── 6b. Section Expertise ─────────────────────────── */
  const expSection = document.querySelector('.exp-section');
  if (expSection) {
    const expHeader = expSection.querySelector('.exp-header');
    const expPillars = expSection.querySelectorAll('.exp-pillar');
    const expFounder = expSection.querySelector('.exp-founder');

    if (expHeader) {
      gsap.fromTo(
        expHeader.children,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.65, stagger: 0.12, ease: 'power2.out',
          scrollTrigger: { trigger: expHeader, start: 'top 82%', toggleActions: 'play none none none' }
        }
      );
    }

    if (expPillars.length) {
      gsap.fromTo(expPillars,
        { opacity: 0, y: 48, scale: 0.97 },
        { opacity: 1, y: 0, scale: 1, duration: 0.65, stagger: 0.14, ease: 'back.out(1.3)',
          scrollTrigger: { trigger: expPillars[0], start: 'top 85%', toggleActions: 'play none none none' }
        }
      );
    }

    if (expFounder) {
      const founderPhoto = expFounder.querySelector('.exp-founder__photo-wrap');
      const founderContent = expFounder.querySelector('.exp-founder__content');

      if (founderPhoto) gsap.fromTo(founderPhoto,
        { opacity: 0, x: -40 },
        { opacity: 1, x: 0, duration: 0.8, ease: 'power3.out',
          scrollTrigger: { trigger: expFounder, start: 'top 82%', toggleActions: 'play none none none' }
        }
      );
      if (founderContent) gsap.fromTo(founderContent,
        { opacity: 0, x: 40 },
        { opacity: 1, x: 0, duration: 0.8, ease: 'power3.out', delay: 0.1,
          scrollTrigger: { trigger: expFounder, start: 'top 82%', toggleActions: 'play none none none' }
        }
      );
    }
  }

  /* ─── 7. Footer ──────────────────────────────────────── */
  const footer = document.querySelector('.footer');
  if (footer) {
    gsap.fromTo(footer,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: footer, start: 'top 95%', toggleActions: 'play none none none' }
      }
    );
  }

  /* ─── 8. Hover CTA ───────────────────────────────────── */
  document.querySelectorAll('.button--primary').forEach(btn => {
    btn.addEventListener('mouseenter', () => gsap.to(btn, { scale: 1.04, duration: 0.2, ease: 'power1.out' }));
    btn.addEventListener('mouseleave', () => gsap.to(btn, { scale: 1,    duration: 0.2, ease: 'power1.out' }));
  });

  /* ══════════════════════════════════════════════════════
     A. WORD REVEAL — titres à fort impact narratif
  ══════════════════════════════════════════════════════ */

  /* Pivot narratif — "Avant / Après Coquillettes club" */
  wordReveal(
    document.querySelector('[data-gsap-words="probleme-solution"]'),
    { stagger: 0.07, duration: 0.7 }
  );

  /* Preuve sociale — "Ils ont goûté l'aventure" */
  wordReveal(
    document.querySelector('[data-gsap-words="avis-title"]'),
    { stagger: 0.08, duration: 0.65 }
  );

  /* ══════════════════════════════════════════════════════
     C. COMPTEURS — chiffres de preuve sociale
  ══════════════════════════════════════════════════════ */

  /* Note globale 4.9 */
  counterAnimate(
    document.querySelector('.avis-header__score-number'),
    1,
    { duration: 1.8 }
  );

  /* Nombre d'avis (ex: 127) */
  counterAnimate(
    document.querySelector('.avis-score-count-number'),
    0,
    { duration: 2.2 }
  );

  /* +700 familles dans image-with-text — injection dynamique du span */
  document.querySelectorAll('.image-with-text__text').forEach(div => {
    if (div.innerHTML.indexOf('+700') !== -1) {
      div.innerHTML = div.innerHTML.replace('+700', '+<span class="iwt-stat-number">700</span>');
    }
  });
  counterAnimate(
    document.querySelector('.iwt-stat-number'),
    0,
    { duration: 2.5, ease: 'power1.out' }
  );
}
